import settings from "./addStandard/settings";
import projectOrder from "./projectOrder/settings";
import orderTask from "./orderTask/settings";
import check from "./check/settings";
export default {
  ...settings,
  ...projectOrder,
  ...orderTask,
  ...check,
};



// WEBPACK FOOTER //
// ./src/locales/lang/en-US/indexEn.js